var enMessages = {
  UNKNOWN_ERROR_MESSAGE: `The application has encountered an unknown error. Please try again!`,
  AGENT_UPLOAD_LICENSE_ERROR: 'Upload files unsuccessfully',
  AGENT_REGISTER_SUCCESS: 'Your application form has been submitted successfully. We will contact you shortly!  ',
  CHANGE_PASSWORD_SUCCESS: 'Change password successfully, please go to login page and login again.',
  PASS_WORD_HINT_TEXT: `
  <div class="text-red-1">※Please do not copy and paste to avoid input errors.</div>
              <div style={{ marginTop: 10 }}>
                <div class="fw-500">***Password setting rules***</div>
                <div>&bull;&nbsp; Passwords must be at least 8 characters long.</div>
                <div>&bull;&nbsp; Passwords must contain at least one uppercase letter (A-Z), one lowercase letter (a-z), one number (0-9) and one special character (e.g . ! @ # $ etc..).</div>
              </div>`,
  PASSWORD_INVALID: 'Please enter the valid password',
  SEND_MAIL_FORGOT_PASSWORD_SUCCESS: 'Please check your email to reset password',
  AGENT_UPDATE_PROFILE_SUCCESS: 'Update agent profile successfully',
  VALIDATE_REQUIRED: 'Please fill out this field',
  PHONE_NUMBER_INVALID: 'Invalid Phone Number',
  EMAIL_INVALID: 'Invalid Email',
  INPUT_ROMANJI_CHAR: 'Please input Roman alphabets only.',
  BOOKING_INPROGRESS_TITLE: 'Booking in Progress',
  BOOKING_INPROGRESS_CONTENT: 'There is an unexpected interruption. Please contact our staff to check the booking status',
  BOOKING_UNSUCCESSFUL: 'Booking unsuccessful',
  BOOKING_CARD_INVALID: 'The payment cannot be processed successfully. Please try again!',
  PAYMENT_FAILED: 'Payment Failed',
  PARTIAL_BOOKING_TIMEOUT_MESSAGE: 'Your booking has expired for confirmation, Please contact our staff to check the booking status',
  LOADING_MODAL_MESSAGE: 'Just a moment, please!',
  DO_NOT_CLOSE_BROWSER: "Please don't close or refresh your browser.",
  LoginSessionExpiredTitle: 'Session Expired',
  LoginSessionExpiredContent: 'Please login again.',
  ServerInternalException: 'Error occurred during request processing.',
  RecordNotFoundWithSpecifiedId: 'The record could not be found.',
  UnableToCancelNtaBookingOnCheckinDate:
    'Unable to cancel NTA booking from this system on and after the day of check-in. Please contact our NTA Emergency Call Center +81-50-3646-9371 (English & Japanese)',
};

export default enMessages;
